/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFLocale } from './CRSFLocale';
import {
    CRSFLocaleFromJSON,
    CRSFLocaleFromJSONTyped,
    CRSFLocaleToJSON,
} from './CRSFLocale';

/**
 * 
 * @export
 * @interface CRSFValidationTriggerResponse
 */
export interface CRSFValidationTriggerResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationTriggerResponse
     */
    account_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFValidationTriggerResponse
     */
    datapoint?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFValidationTriggerResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFValidationTriggerResponse
     */
    dry_run?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFValidationTriggerResponse
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationTriggerResponse
     */
    issue?: string;
    /**
     * 
     * @type {CRSFLocale}
     * @memberof CRSFValidationTriggerResponse
     */
    locale?: CRSFLocale;
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationTriggerResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationTriggerResponse
     */
    quote_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationTriggerResponse
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationTriggerResponse
     */
    user?: string;
}

/**
 * Check if a given object implements the CRSFValidationTriggerResponse interface.
 */
export function instanceOfCRSFValidationTriggerResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function CRSFValidationTriggerResponseFromJSON(json: any): CRSFValidationTriggerResponse {
    return CRSFValidationTriggerResponseFromJSONTyped(json, false);
}

export function CRSFValidationTriggerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFValidationTriggerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_id': !exists(json, 'account_id') ? undefined : json['account_id'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'domains': json['domains'],
        'dry_run': !exists(json, 'dry_run') ? undefined : json['dry_run'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'issue': !exists(json, 'issue') ? undefined : json['issue'],
        'locale': !exists(json, 'locale') ? undefined : CRSFLocaleFromJSON(json['locale']),
        'process_id': json['process_id'],
        'quote_id': !exists(json, 'quote_id') ? undefined : json['quote_id'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function CRSFValidationTriggerResponseToJSON(value?: CRSFValidationTriggerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_id': value.account_id,
        'datapoint': value.datapoint,
        'domains': value.domains,
        'dry_run': value.dry_run,
        'force': value.force,
        'issue': value.issue,
        'locale': CRSFLocaleToJSON(value.locale),
        'process_id': value.process_id,
        'quote_id': value.quote_id,
        'request_origin': value.request_origin,
        'user': value.user,
    };
}

